var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "UiPopover",
    {
      ref: "popover",
      attrs: {
        "z-index": 99,
        containFocus: true,
        dropdownPosition: _vm.position,
      },
      on: { close: _vm.handleClose, open: _vm.handleOpen },
    },
    [
      _c("UiMenu", {
        ref: "menu",
        attrs: { options: _vm.options, hasIcons: _vm.hasIcons },
        on: { select: _vm.handleSelection },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }